module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "epg",
    class: [{
      'epg--fixed': _vm.fixedHeader,
      'epg--show': _vm.showEpg
    }]
  }, [_c('div', {}, [_c('Days', {
    ref: "epgDays",
    attrs: {
      "now-label": _vm.now_label[_vm.lang],
      "selected-date": _vm.selectedDate,
      "today-label": _vm.today_label[_vm.lang]
    },
    on: {
      "epgSelectDay": _vm.selectDay,
      "epgNow": _vm.now
    }
  }), _vm._v(" "), (_vm.channels.length > 0) ? _c('Channels', {
    ref: "epgChannels",
    attrs: {
      "expanded-slot-height": _vm.expandedSlotHeight,
      "default-expanded-slot-height": _vm.defaultExpandedSlotHeight,
      "default-time-slot-height": _vm.defaultTimeSlotHeight,
      "images": _vm.channelImages,
      "channels": _vm.channels,
      "empty-image-url": _vm.emptyImageUrl
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "epg__timeline-wrapper"
  }, [_c('div', {
    class: ['epg__timeline--notransition'],
    attrs: {
      "draggable": "false"
    },
    on: {
      "mousemove": _vm.handleDragMove,
      "touchmove": _vm.handleDragMove,
      "mousedown": _vm.onDragStart,
      "mouseup": _vm.onDragEnd,
      "mouseleave": _vm.onDragEnd,
      "touchstart": _vm.onDragStart
    }
  }, [_c('div', {
    staticClass: "epg__btn epg__btn--left",
    on: {
      "click": function($event) {
        _vm.previousPage()
      }
    }
  }, [_c('svg', {
    staticClass: "epg__chevron"
  }, [_c('use', {
    attrs: {
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xlink:href": "#icon-chevron-left"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "epg__btn epg__btn--right",
    on: {
      "click": function($event) {
        _vm.nextPage()
      }
    }
  }, [_c('svg', {
    staticClass: "epg__chevron"
  }, [_c('use', {
    attrs: {
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xlink:href": "#icon-chevron-right"
    }
  })])]), _vm._v(" "), (_vm.showLoader) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "timeline",
    class: ['epg__inner--notransition'],
    style: (_vm.styles)
  }, [(_vm.showNowElements) ? _c('div', {
    staticClass: "epg__now-time-label",
    style: ('left:' + _vm.nowOffset)
  }) : _vm._e(), _vm._v(" "), (_vm.showNowElements) ? _c('div', {
    staticClass: "epg__now-time-cover",
    style: ('width:' + _vm.nowOffset)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "epg__times epg__timeslots"
  }, _vm._l((_vm.slotsByMinutes), function(d) {
    return _c('div', {
      staticClass: "epg__timeslot",
      style: (("width:" + (_vm.pixelsPerMinute * 30) + "px"))
    }, [_vm._v("\n            " + _vm._s(d) + "\n          ")])
  })), _vm._v(" "), (_vm.channels.length > 0) ? _c('div', [_c('transition', {
    attrs: {
      "name": "fade--area"
    }
  }, [(!_vm.showLoader && _vm.channels.length > 0) ? _c('div', _vm._l((_vm.channels), function(ch, index) {
    return _c('ChannelRow', {
      key: ch.id + index,
      attrs: {
        "timeline-rect": _vm.timelineRect,
        "pre-cache-height": _vm.channelsToPreCache * _vm.channelHeight,
        "horizontal-debounce": _vm.horizontalDebounce,
        "set-channel-visibility": _vm.setChannelVisibility,
        "is-grabbed": _vm.containerPos,
        "is-scrolling": _vm.isScrolling,
        "channel": ch,
        "pixels-per-minute": _vm.pixelsPerMinute,
        "container-pos": _vm.containerPos,
        "timeline-width": _vm.timelineWidth,
        "selectProgram": _vm.selectProgram,
        "more-label": _vm.more_label[_vm.lang],
        "less-label": _vm.less_label[_vm.lang],
        "close-slot": _vm.clearSelectedProgram,
        "default-expanded-slot-height": _vm.defaultExpandedSlotHeight,
        "default-time-slot-height": _vm.defaultTimeSlotHeight,
        "expanded-slot-height": _vm.expandedSlotHeight,
        "description-truncation-point": _vm.descriptionTruncationPoint,
        "set-expanded-slot-height": _vm.setExpandedSlotHeight,
        "show-program-loader": _vm.showProgramLoader,
        "selected-program": _vm.selectedProgram
      }
    })
  })) : _vm._e()])], 1) : _vm._e()])])]), _vm._v(" "), (_vm.showPagination && _vm.selectedFilters.length === 0 && !_vm.pagination.isLast) ? _c('div', {
    staticClass: "epg__pagination align--center",
    on: {
      "click": _vm.showMore
    }
  }, [_c('div', {
    staticClass: "button button--transparent button--white"
  }, [_vm._v(_vm._s(_vm.pagination_label[_vm.lang]))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader__spinner-container epg__loader"
  }, [_c('div', {
    staticClass: "loader__spinner"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48f64b04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Epg/Epg.vue
// module id = 233
// module chunks = 1